import React, { useRef } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick'
import { useModal } from '../../contexts/ModalContext';



const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1100,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: false,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 1199,
      settings: { slidesToShow: 3, },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 2, },
    },
    {
      breakpoint: 599,
      settings: { slidesToShow: 1, },
    },
  ],
};

export default function WeddingSlider({ data, isBtn=true }) {
  const sliderRef = useRef(null);
      const { openQueryModal } = useModal();


  const CustomArrows = () => (
    <>
      {/* <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="Longarrow_left" />
        </div> */}
      <div className="roomgallery-arrow" onClick={() => sliderRef.current.slickNext()}>
        <img src="/image/longright-arrow.svg" alt="arrow" loading="lazy" />
      </div>
    </>
  );

  return (
    <>
      <section className={`wedding-slider-area ${data?.newClass}`}>
        <h3 className="heading center-heading">{data?.heading}</h3>
        <Slider {...settings} ref={sliderRef}>
          { data?.slides?.map((slide, index) => (
              <div key={index} className="wedding-slide">
                <img src={slide?.image} alt="wedding" className="img-responsive" />
                <span dangerouslySetInnerHTML={{ __html: slide?.title }} />
                <p>{slide?.desc}</p>
              </div>
            ))}
        </Slider> 
        <CustomArrows />
        {isBtn && 
        <Link onClick={openQueryModal} className='default-btn color-btn'>Request for Proposal</Link>
        }
      </section>
    </>
  )
}
